// extracted by mini-css-extract-plugin
module.exports = {"enabled":"static--enabled--HuBvh","desktopSidebarIsToggleable":"static--desktopSidebarIsToggleable--kCpvQ"};